<template>
  <button
    @click="$emit('click')"
    class="shadow-md bg-card rounded-lg my-2 text-left flex items-center focus:outline-none flex-1">
    <span class="flex-1 px-3 py-4 text-secondary_text">
      <slot />
    </span>  
    <span class="px-3">
      <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45"><g transform="translate(-138.847 -738.015) rotate(45)"><path d="M664.994,410.6a.684.684,0,0,0-.967,0l-11.666,11.666-11.894-11.894a.684.684,0,1,0-.967.967l11.894,11.894L639.5,435.126a.684.684,0,0,0,.967.967L652.361,424.2l11.666,11.666a.684.684,0,1,0,.967-.967l-11.666-11.666,11.666-11.666A.684.684,0,0,0,664.994,410.6Z" fill="#e3064a"/></g></svg>
    </span>
  </button>
</template>

<script>
export default {
}
</script>

<style>

</style>